<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">

          <div class="row">
            <div class="col-md-12">
              <div class="invite-users-side-padding">

                <card-section-header
                    title="Invite Contractor"
                    icon="fas fa-user-plus"
                    >
                </card-section-header>

                <ng-container *ngIf="!existingContractorMode">
                  <h4 class="card-title">Search</h4>

                  <p>The company you wish to set up might already use Skylark and just need linked to your sites</p>
                  <p>A full list of contractors using Skylark is available here</p>

                  <form [formGroup]="findContractorForm" (ngSubmit)="onFindContractorSubmit()">
                    <br>
                    <div class="form-row" *ngIf="siteOwners.length > 1">
                      <div class="col-md-6">
                        <div class="form-group">
                          <h6>Site Owner</h6>
                          <p-dropdown
                            class="form-control"
                            [(ngModel)]="selectedSiteOwner"
                            [ngModelOptions]="{standalone: true}"
                            [options]="siteOwners"
                            (ngModelChange)="selectedSiteOwnerChange()"
                            placeholder="Select a site owner..."
                            [style]="{'width':'100%'}"
                            filter="true"
                          ></p-dropdown>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Contractors</label>
                          <p-dropdown
                            [disableControl]="!contractorsOptionsList.length"
                            class="form-control"
                            formControlName="contractor"
                            [options]="contractorsOptionsList"
                            placeholder="Search contractors..."
                            required="true"
                            [style]="{ width: '100%' }"
                            filter="true"
                          ></p-dropdown>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <button type="submit" class="btn btn-success btn-round" style="margin-top: 28px" [disabled]="!siteOwnerId || !findContractorForm.valid || saveInProgress" (click)="onFindContractorSubmit()">
                          Link contractor
                        </button>
                      </div>
                    </div>
                  </form>

                  <br>
                  <hr>
                  <br>
                  <p>Or set up a new company:</p>
                </ng-container>

                <h4 class="card-title">Company</h4>

                <form [formGroup]="form" (ngSubmit)="onSubmit()">

                  <ng-container *ngIf="!existingContractorMode">
                    <div class="form-row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Company Name <span class="required-star">*</span></label>
                          <input type="text" class="form-control" formControlName="companyName" placeholder="">
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Additional Details</label>
                          <textarea type="text" class="form-control" formControlName="additionalInfo"></textarea>
                        </div>
                      </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="existingContractorMode && existingContractor">
                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Company Name <span class="required-star">*</span></label>
                        <p>{{existingContractor.name}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Additional Details</label>
                        <p>{{existingContractor.additionalInfo}}</p>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <h4 class="card-title">Company manager</h4>

                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>First Name <span class="required-star">*</span></label>
                        <input type="text" class="form-control" formControlName="firstName" placeholder="">
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Last Name <span class="required-star">*</span></label>
                        <input type="text" class="form-control" formControlName="lastName" placeholder="">
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Email Address <span class="required-star">*</span></label>
                        <input type="text" class="form-control" formControlName="email" placeholder="">
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Phone number <span class="required-star">*</span></label>
                        <input type="text" class="form-control" formControlName="phoneNumber" placeholder="">
                      </div>
                    </div>

                  </div>

                </form>
              </div>
              <br>
              <div class="col-md-12">
                <label>Required Contractor Competencies</label>
                <br>
                <p *ngIf="!competencies.length">
                  No required competencies, this contractor will be approved straight away
                </p>
                <div *ngFor="let competency of competencies" class="compblock">
                  <div class="compblock-details">
                    <b>{{competency.label}}</b>
                    <ul>
                      <li>requires certificate</li>
                      <li>requires Site Operator approval</li>
                      <ng-container *ngIf="isHuntstown">
                        <li *ngIf="extraCompetencyInfo[competency.id]">{{extraCompetencyInfo[competency.id]}}</li>
                      </ng-container>
                    </ul>
                  </div>
                  <button type="button" class="btn btn-danger btn-link" (click)="removeCompetency(competency.id)">delete</button>
                </div>
                <button type="button" class="btn btn-success btn-round" [disabled]="!competencyOptions.length" (click)="openRequiredCompetencyModal()">Add</button>
              </div>

              <br>
              <div class="col-md-12">
                <button type="submit" class="btn btn-success btn-round" [disabled]="!form.valid || saveInProgress" (click)="onSubmit()">
                  Send invite
                </button>
              </div>
              <br>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #dismissValidationButton let-liveSession>
  <button type="button" class="close" (click)="addUserFormValidated = false" aria-label="Close"><span aria-hidden="true">&times;</span></button>
</ng-template>
